import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Stepper,
  StepperProps,
  Step as BaseStep,
  StepProps as BaseStepProps,
  StepLabel,
  StepContent,
  Typography
} from '@material-ui/core';

export type Props = StepperProps;

export type StepProps = BaseStepProps & {
  number?: number;
};

export const Step = ({ number, children, ...stepProps }: StepProps) => {
  const { t } = useTranslation('AdminRosterManagement');

  return (
    <BaseStep active expanded {...stepProps}>
      <StepLabel active icon={null}>
        <Typography variant="h3">{t('step', { number })}</Typography>
      </StepLabel>
      <StepContent>{children}</StepContent>
    </BaseStep>
  );
};

const SteppedInstructions = ({ children, ...stepperProps }: Props) => {
  return (
    <Stepper orientation="vertical" {...stepperProps}>
      {children}
    </Stepper>
  );
};

export default SteppedInstructions;
